import { type ReactElement, useEffect } from 'react'
import { NotReady } from '@components'
import { Button, Container, Stack, Text } from '@mantine/core'
import { useAuthSession } from '@util'
import { createFileRoute } from '@tanstack/react-router'

function Login(): ReactElement {
  const { isAuthenticated, isLoading, redirectToLogin } = useAuthSession()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      redirectToLogin('/home')
    }
  }, [isLoading, isAuthenticated, redirectToLogin])

  if (isLoading) return <NotReady isLoading />

  if (isAuthenticated) {
    return (
      <Container py='xl' size='sm'>
        <Stack align='center' gap='md'>
          <Text size='lg'>You are already signed in.</Text>
          <Button onClick={() => (window.location.href = '/home')}>Go to Dashboard</Button>
        </Stack>
      </Container>
    )
  }

  return (
    <Container py='xl' size='sm'>
      <Stack align='center' gap='md'>
        <Text size='lg'>Redirecting to sign in...</Text>
        <Button onClick={() => redirectToLogin('/home')}>Continue to Sign In</Button>
      </Stack>
    </Container>
  )
}

export const Route = createFileRoute('/login/')({
  component: Login,
})
